import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../assets/logo.svg';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="landing-footer-container layout-footer">
      <div className="footer-content">
        <div className="footer-logo">
          <Link to="/">
            <img src={Logo} alt="Valuera Logo" className="footer-logo-img" />
          </Link>
        </div>
        <div className="footer-links">
          <a href="/#impressum">Impressum</a>
          <a href="/#datenschutz">Datenschutz</a>
          <a href="/#agb">AGB</a>
        </div>
        <p className="footer-copy">
          &copy; 2026 Valuera. Alle Rechte vorbehalten. Built with React and
          TypeScript.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
